<mat-dialog-content>
  <pinch-zoom
    #zoom
    (events)="events($event)"
    [auto-zoom-out]="true"
    [autoHeight]="true"
    [disableZoomControl]="'never'"
    [double-tap-scale]="4.5"
    [limit-zoom]="4.5"
    [limitPan]="true"


    [ngStyle]="{
    'width.px': containerWidth$ | async,
    'height.px': containerHeight$ | async,
    'border-radius.%':rounding
  }"
    [properties]="pinchProps"
    [zoomControlPosition]="'right'"
    [zoomControl]="'two-buttons'"
    backgroundColor="transparent"
    overflow="hidden"
  >
    <img
      #img
      [src]="
                  {photoId:photoId}
                    | getImageUrl
                      : (photoId | getPhotoGroupFromPhotoId:imageRelations)
                      : 'anyone'
                      : context
                      : contextId
                      : 1200

  | async"
      draggable="false"
      (load)="imageLoaded$.next(undefined)"
    />

  </pinch-zoom>
</mat-dialog-content>
<mat-dialog-actions>
  <lib-button (click)="save()">Zapisz</lib-button>
  <lib-button bare mat-dialog-close>Anuluj</lib-button>
</mat-dialog-actions>
